<template>
    <div class="filedsContainer">

        <div class="head">
            <div class="tabs">
                <el-tabs v-model="activeName"  >
                    <el-tab-pane label="资质" name="first">
                    </el-tab-pane>
                    <el-tab-pane label="商品" name="second">
                    </el-tab-pane>
                    <el-tab-pane label="订单" name="third">
                    </el-tab-pane>
                    <el-tab-pane label="售后单据" name="fourth">
                    </el-tab-pane>
                </el-tabs>
            </div>
            <div class="footer"> 
                <el-button size="mini" @click="back">返回</el-button>
            </div>
        </div>
        <div class="body">
            <div class="chlidren">
                <credentials v-if="activeName == 'first'" pageType="record" />
                <goods v-if="activeName == 'second'" pageType="record" />
                <order v-if="activeName == 'third'" pageType="record" />
                <afterSales v-if="activeName == 'fourth'" pageType="record" />
            </div>
        </div>
    </div>
</template>
<script>
import credentials from "./credentials.vue";
import goods from "./goods.vue";
import order from "./order.vue";
import afterSales from "./afterSales.vue";

export default {
    name: "QAuditDetail",
    components: { credentials, afterSales, order, goods },
    watch: {
        modeValue: {
            immediate: true,
            handler: function (value) {
                console.log(value, "value");
            },
        },
    },
    data() {
        return {
            disabled: false,
            qualified: 1,
            activeName: "first",
            type: "approve", // view
            status: null,
            roleId: null,
            relationType: null,
            shopTypeName: null,
            shopName: null,
            orgCode: null,
            deptId: null,
            remarks: "",
            infoDetailData: {},
            queryScopeListData: [],
        };
    },
    methods: {

        back() {
            this.$router.go(-1);
        },

    },
    mounted() {

    },
};
</script>
<style lang="scss" scoped>
.filedsContainer {
    display: flex;
    flex-flow: column;
    height: 100%;
    overflow-y: auto;

    .head {
        background: #ffffff;
        height: 76px;
        padding: 10px 20px 0px 20px;
        line-height: 28px;
        display: flex;
        justify-content: space-between;
        border-bottom: solid 1px #F2F2F2;
    }

    .tabs {
        height: 60px;
    }

    .font-tip {
        padding-left: 20px;
        font-size: 12px;
    }

    .body {
        background: #ffffff;
        padding: 20px 20px 10px;
        display: flex;
        flex: 1;
        overflow-y: auto;
    }

    .chlidren {
        width: 100%;
    }

    .footer {
        padding: 20px 0 0;
        background: #ffffff;
    }

    .check-cotent {
        margin-top: 10px;
        //  width: calc(100% - 200px);
    }
}
</style>
  